import { IFormularioRespostaControle } from "@/interfaces/IFormularioRespostaControle";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface FormularioControleRespostaState {
  items: IFormularioRespostaControle[];
  synced?: boolean;
  updatedAt?: number;
}

const initialState: FormularioControleRespostaState = {
  items: [],
  synced: false,
};

const formularioControleRespostaSlice = createSlice({
  name: "FORMULARIO_CONTROLE_RESPOSTA",
  initialState,
  reducers: {
    sync: (
      state,
      action: PayloadAction<{ items: IFormularioRespostaControle[] }>
    ) => {
      const { items } = action.payload;

      state.items = [...state.items, ...items];
      state.synced = true;
      state.updatedAt = Date.now();
    },

    removeMunicipio: (
      state,
      action: PayloadAction<{ municipioId: number }>
    ) => {
      const { municipioId } = action.payload;
      state.items = state.items.filter(
        (item) => item.municipio.id !== municipioId
      );
    },
  },
});

export default formularioControleRespostaSlice.reducer;

export const getFormularioControleRespostaSynced = (state: RootState) =>
  state.formularioControleResposta.items;

export const getFormularioControleRespostaIsSynced = (state: RootState) =>
  state.formularioControleResposta.synced;

export const getCountMunicipiosSynced = (state: RootState) => {
  const municipiosIds = state.formularioControleResposta.items.map(
    (f) => f.municipio.id
  );
  const uniqueMunicipiosIds = Array.from(new Set(municipiosIds));
  return uniqueMunicipiosIds.length;
};

export const getMunicipiosSincronizados = (state: RootState) => {
  const items = state.formularioControleResposta.items;
  const municipiosMap = new Map();

  items.forEach((item) => {
    if (!municipiosMap.has(item.municipio.id)) {
      municipiosMap.set(item.municipio.id, {
        id: item.municipio.id,
        nome: `${item.municipio.nome}-${item.municipio.uf.sigla}`,
        quantidadeFormularios: 0,
        dataUltimaAtualizacao: item.dataUltimaResposta,
      });
    }

    const municipio = municipiosMap.get(item.municipio.id);
    municipio.quantidadeFormularios += 1;
  });

  return Array.from(municipiosMap.values());
};
